import { useState } from "react";
import React from "react";
import { ComposedModal, Button, ModalBody, ModalHeader, Grid, Row, Column } from "carbon-components-react";

function FsaPlanDetails() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ComposedModal open={open} onClose={() => setOpen(false)}>
        <ModalHeader className="mt-6 mb-2 -ml-4">
          <p className=" text-2xl">Flexible Spending Accounts (FSA) Plan Details</p>
          <p>Administered by UMR</p>
        </ModalHeader>
        <ModalBody aria-label="Plan Details">
          <div className="-ml-10 px-4 sm:mr-16 sm:-ml-4">
          <Grid className="mb-6 bg-gray-200">
            <Row>
              <Column className="font-bold text-red-600 mb-2 mt-2">Medical Spending Account</Column>
            </Row>
            <Row>
              <Column className="mb-2">Plan Year maximum election</Column>
              <Column>$3,200</Column>
            </Row>
            <Row>
              <Column className="mt-2 mb-2 font-bold text-red-600">Dependent Care Spending Account</Column>
            </Row>
            <Row>
              <Column className="mb-4">Plan Year maximum election</Column>
              <Column>$5,000</Column>
            </Row>
          </Grid>
          </div>
          <div className="mb-8 -ml-2 sm:ml-0">
            <div className="font-bold text-red-600 mb-2 mt-2">Important Information</div>
            <p className="mt-2">
              • You may choose to participate in one, both or neither plan - the choice is yours. The amounts you choose to contribute are divided over the number of pay periods and are deductible on a pre-tax basis, which lowers your taxable income. <br/><br/>• The money you put in your "Medical Spending" account can be used for eligible expenses, which include co-payments, co-insurance, prescription drugs, dental, vision and orthodontic services. The plan includes a convenient Debit Card, which gives you instant access to
              Flex Accounts funds.<br/><br/>• Dependent Care account reimburses you for costs related to caring for a dependent while you or your spouse work. Eligible dependents include your children under age 13, your spouse, if mentally or physically disabled, and any other person who is a qualified dependent, who is mentally or physically incapable of self-care and who resides in your home for a minimum of 8 hours per day.<br/>
              <br/>*Please plan very carefully. Contribute only as much as you know you are going to spend during the plan year. The IRS requires that any money left unused at the end of the plan year be forfeited. Over-the-counter medications are NOT eligible expenses under the plan, unless you have a prescription from your doctor on file. Once enrolled, you cannot increase, decrease or cease your deductions unless you experience a qualifying event.
            </p>
          </div>
        </ModalBody>
      </ComposedModal>
      <Button kind="ghost" onClick={() => setOpen(true)}>
        View Plan Details
      </Button>
    </>
  );
}

export default FsaPlanDetails;
